import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DoneIcon, RequiredUserActionIcon } from 'common/icons';
import { DateCell } from 'common/components';
import classNames from 'classnames';
import { withTheme } from 'common/styling/theme';
import { staticStyles, getDynamicStyles } from './style';

const PaymentStatus = ({ event, isLastEvent, statusGroup, theme, isRequiresUserAction }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const isIncompleteProcessing = isRequiresUserAction && statusGroup?.color === 'processing';
  return (
    <div
      className={classNames('PaymentStatus', {
        [`PaymentStatus-${statusGroup?.color || 'processing'}`]: isLastEvent,
        'PaymentStatus-new': event.newEvent,
        'PaymentStatus-existing': !event.newEvent,
      })}>
      <div className="PaymentStatus-icon">
        {isLastEvent ? (
          isIncompleteProcessing ? (
            <RequiredUserActionIcon />
          ) : (
            statusGroup?.icon || <DoneIcon />
          )
        ) : (
          <DoneIcon />
        )}
      </div>
      <div className="PaymentStatus-info">
        {statusGroup?.title ? (
          <div className="PaymentStatus-info-container">
            <FormattedMessage id={statusGroup?.title}>
              {txt => <p className="PaymentStatus-info-title">{txt}</p>}
            </FormattedMessage>
            {isIncompleteProcessing && (
              <div>
                <FormattedMessage id="justIncomplete">
                  {txt => <p className="PaymentStatus-info-incomplete">{txt}</p>}
                </FormattedMessage>
              </div>
            )}
          </div>
        ) : (
          <p className="PaymentStatus-info-title">{event.status}</p>
        )}
        <DateCell value={event.updated} inLine grey />
      </div>

      <style jsx global>
        {staticStyles}
      </style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

PaymentStatus.propTypes = {
  event: PropTypes.object.isRequired,
  isLastEvent: PropTypes.bool.isRequired,
  statusGroup: PropTypes.object.isRequired,
  theme: PropTypes.object,
  isRequiresUserAction: PropTypes.bool.isRequired,
};

PaymentStatus.defaultProps = {
  theme: {},
};

PaymentStatus.defaultProps = {};

export default withTheme()(PaymentStatus);
export { PaymentStatus };
